import React, { Component } from "react";
import styles from "./monitoringTaskTripUnitsBar.module.scss";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import { withUnits } from "../../../../shared/containers/containerUnits";
import { getCarsTypeName } from "../../../sections/cars/static.carsTypes";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import { Radio } from "@mui/material";

class MonitoringTripRoutesUnitItem extends Component {
  onClickHandler() {
    const { monitoringSettingsState, onSetMonitoringSettingsState, data, monitoringTaskTrip } = this.props;

    if (monitoringSettingsState.isModificating) return;

    if (monitoringSettingsState.routeState !== null) {
      monitoringSettingsState.routeState.id = monitoringTaskTrip.id;
      monitoringSettingsState.routeState.unitId = data.id;
      monitoringSettingsState.routeState.unitTitle = data.unit.title;
      monitoringSettingsState.routeState.unitRegisterNumber = data.unit.registerNumber;
    } else {
      monitoringSettingsState.routeState = {
        id: monitoringTaskTrip.id,
        title: monitoringTaskTrip.title,
        unitId: data.id,
        unitTitle: data.unit.title,
        unitRegisterNumber: data.unit.registerNumber,
      };
    }

    onSetMonitoringSettingsState(monitoringSettingsState);
  }

  render() {
    const { data, monitoringTaskTrip, monitoringSettingsState } = this.props;

    if (monitoringTaskTrip === null) return <div></div>;

    const isInTaskTrip = monitoringTaskTrip.units.some((x)=>{
      return x.id === data.id
    })

    if(!isInTaskTrip) return <div></div>

    const getStatusStyles = () => {
      switch (data.unit.inActive ? "inActive" : getCarsTypeName(data.status.id)) {
        case "noData":
          return styles.container_carNumber_noData;
        case "inMove":
          return styles.container_carNumber_inMove;
        case "parking":
          return styles.container_carNumber_parking;
        case "inActive":
          return styles.container_carNumber_inActive;
        default:
          return null;
      }
    };

    const isCheck = monitoringSettingsState.routeState !== null && monitoringSettingsState.routeState.unitId === data.id;

    return (
      <div className={styles.carsListItemWrapper}>
        <div className={styles.container_carsListItemWrapper}>
          <div className={styles.carsListItem}>
            <TooltipWrapper title={data.status.title} position="right">
              <div className={getStatusStyles()}>
                <span className={styles.title}>{data.number}</span>
              </div>
            </TooltipWrapper>

            <div className={styles.carsListItemInner}>
              <div className={styles.container_carContent}>
                <div className={styles.container_name}>
                  <div>{data.unit.title}</div>

                  <div>{data.unit.registerNumber}</div>
                </div>
              </div>

              <div className={styles.container_params}>
                <Radio checked={isCheck} size="small" onClick={this.onClickHandler.bind(this)} />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withMonitoringTaskTrips(withUnits(React.memo(MonitoringTripRoutesUnitItem)));
